import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/multiSession/tenant.multiSession.mutation.gql"
import type {
  TenantMultiSessionMutation,
  TenantMultiSessionMutationVariables,
} from "@/v2-backoffice-client/tenant/multiSession/__types__/tenant.multiSession.mutation"

type Options = MutationHookOptions<
  TenantMultiSessionMutation,
  TenantMultiSessionMutationVariables
>

export function useTenantMultiSessionMutation(options?: Options) {
  return useMutation<
    TenantMultiSessionMutation,
    TenantMultiSessionMutationVariables
  >(mutation, options)
}
